import React, { useEffect, useState } from "react";
import "../styles.css";
import "bootstrap/dist/css/bootstrap.css";
import "../../assets/css/utmlBuilder.css"
import { getToken } from "../../Utils/Common";
import Multiselect from "multiselect-react-dropdown";
import { grey } from "@material-ui/core/colors";
import {
  getAllWebpageTriggerNoLimit,
  getEventDefinationById,
  getEventDefinationSchemaById,
  getEventDefinationSchemaKeyById,
  getEventDefinationScriptById,
  postEventDefinations,
} from "api/EventTriggerApi";
import { toast } from "react-toastify";
import { useHistory } from 'react-router-dom'
import SupportLink from "../Common/SupportLink";

var filters = [];
function CreateEvent(props) {
  const history = useHistory()

  const [dropdown, setDropDown] = useState([]);
  const [audienceName, setAudienceName] = useState("");
  const [description, setDescription] = useState("");
  const [anyOrAll, setAnyOrAll] = useState("OR");
  const [isPreview, setIsPreview] = useState(false);

  const [property, setProperty] = useState([]);
  const [action, setAction] = useState([]);
  const [type, setType] = useState([]);
  const [triggerType, setTriggerType] = useState([]);

  const [editTrigger, setEditTrigger] = useState({});

  const [ts, setTs] = useState("60f553070624d7b2d3bb486e");

  const [state, setState] = useState({ options: [] });

  const [selectedTriggers, setSelectedTriggers] = useState([]);
  const [pageNo, setPageNo] = useState("0");
  const [scriptCode, setscriptCode] = useState("");
  const [eventID, setEventID] = useState("0");
  const [show, setShow] = useState(false);
  const [error, setError] = useState(false);
  const [showScript, setShowScript] = useState(false);
  const [saved, setSaved] = useState(false);
  const [checkBox, setCheckBox] = useState(false);
  const [companyKey, setCompanyKey] = useState("");

  const [conditionFilters, setConditionFilters] = useState([
    {
      filterPropertyId: null,
      filterActionId: null,
      filterValueTypeId: null,
      filterValue: null,
      filterValue2: null,
      optional: false,

      sequenceNo: 1,
      logicalOperator: anyOrAll,
      id1: 0,
      id2: 0,
      inputBox: false,
    },
  ]);
  const [firstCheckbox, setFirstCheckbox] = useState(false);
  const [tag, setTag] = useState("");


  const [isGoal, setisGoal] = useState(false);

  const [conversionValue, setconversionValue] = useState("");
  // setting previous state defaults for sessionStorage
  let previousStates = { isValid: false };
  previousStates.audienceName = audienceName;
  previousStates.description = description;
  previousStates.firstCheckbox = firstCheckbox;
  previousStates.tag = tag;
  previousStates.anyOrAll = anyOrAll;
  previousStates.conditionFilters = conditionFilters;
  function clearCache() {
    setDropDown([]);
    setAudienceName("");
    setDescription("");
    setAnyOrAll("OR");
    setIsPreview(false);
    setProperty([]);
    setAction([]);
    setType([]);
    setTriggerType([]);

    setEditTrigger({});
    setState({ options: [] });
    setSelectedTriggers([]);
    setPageNo("0");
    setscriptCode("");
    setEventID("0");
    setShow(false);
    setError(false);
    setShowScript(false);
    setSaved(false);
    setCheckBox(false);
    setCompanyKey("");
    setConditionFilters([
      {
        filterPropertyId: null,
        filterActionId: null,
        filterValueTypeId: null,
        filterValue: null,
        filterValue2: null,
        optional: false,

        sequenceNo: 1,
        logicalOperator: anyOrAll,
        id1: 0,
        id2: 0,
        inputBox: false,
      },
    ]);
    setFirstCheckbox(false);
    setTag("");
    setisGoal(false);
    setconversionValue("");
  }
  useEffect(() => {
    clearCache();
    getAllWebpageTriggerNoLimit()
      .then((data) => {

        var ss = data;
        var tt = { options: ss };
        setState(tt);
        var url_string = window.location.href;
        var url = new URL(url_string);
        var eeID = url.searchParams.get("event");
        if (eeID) {
          setSaved(true);
          getEventDefinationById(eeID)
            .then((ed_data) => {
              setAudienceName(ed_data.name);
              setDescription(ed_data.description);
              var ts = [];
              ed_data.webpageTriggers.forEach((e) => {
                tt.options.forEach((a) => {
                  if (a.id == e.webpageTriggerId) {
                    ts.push(a);
                  }
                });
              });
              setSelectedTriggers(ts);

              setCheckBox(ed_data.isTriggered);
              setShow(ed_data.isTriggered);
              if (!ed_data.isTriggered) {
                getEventDefinationSchemaById(eeID)
                  .then((data) => {
                    var allsc = [];
                    data.forEach((e) => {
                      var x = {
                        filterPropertyId: null,
                        filterActionId: null,
                        filterValueTypeId: null,
                        filterValue: null,
                        filterValue2: null,
                        optional: false,

                        sequenceNo: 1,
                        logicalOperator: anyOrAll,
                        id1: 0,
                        id2: 0,
                        inputBox: false,
                      };
                      x.filterValue = e.label;
                      x.filterActionId = e.dataType;
                      x.optional = e.isOptional;
                      allsc.push(x);
                    });
                    setConditionFilters(allsc);
                  })
                  .catch((e) => { });
              }
              if (!ed_data.isTriggered) {
                getEventDefinationSchemaKeyById(ed_data.id)
                  .then((res_data) => {
                    //setCompanyKey(res_data.companyKey);
                    setscriptCode(formatMessage(res_data));
                    setShowScript(true);
                  })
                  .catch((e) => { });
              } else {
                getEventDefinationScriptById(ed_data.id)
                  .then((res_data) => {
                    setscriptCode(res_data.script);
                    setShowScript(true);
                  })
                  .catch((e) => { });
              }
              if (ed_data.isGoal) {
                setisGoal(true);
                setconversionValue(ed_data.conversionValue);
              }
            })
            .catch((e) => { });
        }
      })
      .catch(function (error) {

      });
    if (type[1] != null && type[1] != undefined) {
      for (var i = 0; i < filters.length; i++) {
        filters[i].webpageTriggerFilterValueTypeId = type[1].id;
      }
    }
  }, [history.location.search]);

  function onSelect(selectedList, selectedItem) {
    var x = selectedTriggers;
    x.push(selectedItem);
    setSelectedTriggers(x);
  }

  function formatMessage(x){
    let body = JSON.stringify(x.body, undefined, 2)
    let final =  `Method: POST
URL: ${x.url}

Body: ${body}
Note: Kapitalwise system uses Email, PersonId or CookieId to identify the Person associated with the Event.
      One of these parameters are mandatory.  

    `
    return final
  }

  function onRemove(selectedList, removedItem) {
    var x = [];
    for (var t in selectedTriggers) {
      if (t.id != removedItem.id) {
        x.push(t);
      }
    }

    setSelectedTriggers(x);
  }
  function isValid(str) {
    return /^\w+$/.test(str);
  }

  //SECTION Preview Audience
  const previewAudience = (e) => {
    e.preventDefault();

    if (saved) {
      toast.info("The event was saved before");
      return;
    }



    const token = "Bearer " + getToken();

    //  var x = document.getElementById("drop4").value;

    // audienceName
    // description

    var saveData = {
      name: audienceName,
      description: description,
      isGoal: isGoal,
      // eventTypeId: x
      isTriggered: show,
      webpageTriggers: [],
      schema: [],
    };
    if (isGoal) {
      saveData.conversionValue = conversionValue;
    }

    if (!show) {
      var i1 = document.getElementsByClassName("in1");
      for (var ii = 0; ii < i1.length; ii++) {
        if (!isValid(i1[ii].value)) {
          setError(true);
          return;
        }
      }
    }
    setError(false);
    if (show) {
      for (var i = 0; i < selectedTriggers.length; i++) {
        var x = { webpageTriggerId: selectedTriggers[i].id };
        saveData.webpageTriggers.push(x);
      }
      setShowScript(true);
    } else {
      saveData.schema = saveSchema();
      setShowScript(true);

    }
    setError(false);
    var flag = show;
    postEventDefinations(saveData)
      .then((data) => {
        setEventID(data.id);
        if (!flag) {
          getEventDefinationSchemaKeyById(data.id)
            .then((res_data) => {
              //setCompanyKey(res_data.companyKey);
              setscriptCode(formatMessage(res_data));
              
              setTimeout(() => {
                toast.success("The event has been saved successfully!");
              }, 20);
            })
            .catch((e) => { });
        } else {
          getEventDefinationScriptById(data.id)
            .then((res_data) => {
              setscriptCode(res_data.script);
              setTimeout(() => {
                toast.success("The event has been saved successfully!");
              }, 20);
            })
            .catch((e) => { });
        }
        setSaved(true);
      })
      .catch((e) => { });
  };
  const handlecheck = () => {
    setCheckBox(!checkBox);
    setShow(!show);
  };
  const handlecheck2 = () => {
    setisGoal(!isGoal);
  };

  const handleRemove = (id) => {
    const toBeDeleted = [...conditionFilters];
    var i1 = document.getElementsByClassName("in1");
    var i2 = document.getElementsByClassName("in2");
    var i3 = document.getElementsByClassName("opt");

    for (var i = 0; i < toBeDeleted.length; i++) {
      // var a = document.getElementById("typeInput" + i).value;
      // var b = document.getElementById("typeInput2" + i).value;
      toBeDeleted[i].filterValue = i1[i].value;
      toBeDeleted[i].filterValue2 = i2[i].value;
      toBeDeleted[i].optional = i3[i].checked;
    }


    // console.lo

    toBeDeleted.splice(id, 1);

    setConditionFilters(toBeDeleted);
  };
  const creatediv = () => {
    let id = conditionFilters.length - 1;
    let sequence = conditionFilters[id].sequenceNo + 1;
    let temp = [...conditionFilters];
    let objToBeAdded = {
      filterPropertyId: null,
      filterActionId: null,
      filterValueTypeId: null,
      optional: false,

      filterValue: null,
      filterValue2: null,

      sequenceNo: sequence,
      logicalOperator: anyOrAll,
      id1: 0,
      id2: 0,
      inputBox: false,
    };
    temp.push(objToBeAdded);
    setConditionFilters(temp);
  };
  const handleDrop2Change = (e, filtIndex) => {
    let name = e.target.value;

    let temp = [...conditionFilters];
    temp[filtIndex].filterActionId = name;
    setConditionFilters(temp);
  };

  const copy = () => {
    /* Copy the text inside the text field */
    navigator.clipboard.writeText(scriptCode);
  };
  const copy2 = () => {
    /* Copy the text inside the text field */
    navigator.clipboard.writeText(companyKey);
  };
  const handleType = (e, filtIndex) => {
    let name = e.target.value;

    let temp = [...conditionFilters];
    temp[filtIndex].filterValue = name;
    setConditionFilters(temp);
  };
  const saveSchema = () => {
    // e.preventDefault();


    var size = conditionFilters.length;
    var y = [];
    var i1 = document.getElementsByClassName("in1");
    var i2 = document.getElementsByClassName("in2");
    var i3 = document.getElementsByClassName("opt");

    for (var i = 0; i < size; i++) {
      // var a = document.getElementById("typeInput" + i).value;
      // var b = document.getElementById("typeInput2" + i).value;
      var a = i1[i].value;
      var b = i2[i].value;
      // if(b)
      var c = i3[i].checked;

      var x = {
        label: a,
        dataType: b,
        isOptional: c,
      };
      y.push(x);

      //  
    }
    return y;
  };
  const changeCheck = (a, b) => {
    document.getElementById(a).checked = b;
  };
  const clearAll = () => {
    setDropDown([]);
    setAudienceName("");
    setDescription("");
    setAnyOrAll("OR");
    setIsPreview(false);
    setConditionFilters([
      {
        filterPropertyId: null,
        filterActionId: null,
        filterValueTypeId: null,
        filterValue: null,
        sequenceNo: 1,
        logicalOperator: anyOrAll,
        id1: 0,
        id2: 0,
        inputBox: false,
      },
    ]);
  };

  return (
    <div id='crev'>
      <SupportLink link='https://kapitalwise.com/user-guide/tags/' />

      <div className="page_heading">
        <h2>Create Event</h2>
      </div>

      <form onSubmit={previewAudience}>
        <div className="audieneOuter">
          <div className="inputOuter">
            <label className="large">Event Name</label>
            <input
              id="audienceName"
              placeholder="Enter Event Name"
              value={audienceName}
              onChange={(e) => setAudienceName(e.target.value)}
              type="text"
              className="kwDesign max351"
              required
            />
          </div>
          <div className="inputOuter">
            <label className="large">Description</label>
            <textarea
             placeholder="Enter Description"
              id="textArea"
              value={description}
              onChange={(e) => setDescription(e.target.value)}
              className="csTextarea"
              required
            />
          </div>
          <div className="inputOuter">
            {/* <div className="kwCheckboxBlue">
							<input checked={firstCheckbox} onChange={() => setFirstCheckbox(!firstCheckbox)} type="checkbox" id="checkbox1" />
							<label htmlFor="checkbox1" className="kwCheckboxText">
								Tag Audience
							</label>
						</div> */}
          </div>
          {/* <div className="kwCheckbox">
            <input type="checkbox" id="logged_in" onClick={handlecheck} />

            <label className="kwCheckboxText" for="logged_in">
              Webpage
            </label>
          </div> */}
          <div
            style={{
              display: "flex",
              flexDirection: "row",
              alignItems: "center",
             marginLeft:"20px"
            }}
          >
            <input
              id="audienceName"
              type="checkbox"
              onClick={handlecheck}
              checked={checkBox}
            />

            <label className="large" style={{ margin: "1vh" }}>
              Webpage{" "}
            </label>
          </div>

          <div className="" style={{ marginTop: "2vh" , marginLeft:"10px"}}>
            {show ? (
              <div>
                <div id="display" className="inputOuter">

                  <div
                    style={{
                      display: "flex",
                      flexDirection: "row",
                      alignItems: "center",
                      marginBottom: '20'
                    }}
                  >
                    <input
                      id="a2"
                      type="checkbox"
                      onClick={handlecheck2}
                      checked={isGoal}

                    />
                    <label className="large" style={{ margin: "1vh" }}>
                      Goal{" "}
                    </label>
                  </div>

                  {isGoal ?

                    <div style={{ position:'relative', paddinTop: '20px', paddinBottom: '20px' }}>
                      <span
                        style={{
                          position: 'absolute',
                          fontSize: 'large',
                          fontFamily: 'cursive',
                          marginLeft: '12px',
                          top: '2px'
                        }}

                      >$</span>
                      <input style={{ paddingLeft: '40px' }} type="number" className="kwDesign max351" value={conversionValue} onChange={(e) => setconversionValue(e.target.value)} placeholder="Conversion value"></input>

                    </div>

                    : null

                  }

                  <label style={{ marginTop: '22px' }} className="large">Triggers</label>
                  <Multiselect
                    required
                    options={state.options} // Options to display in the dropdown
                    selectedValues={selectedTriggers} // Preselected value to persist in dropdown
                    onSelect={onSelect} // Function will trigger on select event
                    onRemove={onRemove} // Function will trigger on remove event
                    displayValue="name" // Property name to display in the dropdown options
                    style={{
                      optionContainer: {
                        maxHeight: "200px",
                      },
                      option: {
                        // To change css for dropdown options
                        fontSize: "16px",
                        lineHeight: "13px",
                        fontWeight: "400",
                        fontFamily: "Poppins",
                      },
                    }}
                  />
                </div>
                <a></a>
                <h1></h1>
                <div className="contactMatch" style={{marginLeft:"10px"}}>
                  {/* <p className="contactMatchText">
							Contact Match
							<select onChange={(e) => handleAnyOr(e)} id="anyOrand" className="kwDesign1 w69">
								<option value="OR">Any</option>
								<option value="AND">All</option>
							</select>
							of the following conditions.
						     </p> */}
                </div>

                {/* <div
                className="previewAudience"
                style={{ marginTop: "2vh", marginLeft: "3%" }}
              >
                <input
                  type="submit"
                  name="Save"
                  style={{ margin_top: "2v", cursor: "pointer" }}
                  className="lg_btn secondary mb-2"
                  value="Save Event"
                />
              </div> */}
              </div>
            ) : (
              <>
                     <div className="frjoior">
              <span style={{flex:1}}> Event attribute</span>
              <span  style={{flex:1}} > Data type</span>


            </div>
              <div className="contactMatch">
                <div className="addRemoveDetails">
                  {conditionFilters &&
                    conditionFilters.map((filtObj, filtId) => {
                      const parentId = filtObj.id1;
                      const isActive = filtId == 0 ? true : false;




                      //@Boney: Filter options Component starts here

                      return (
                        <ul key={filtId} id="container">
                          <li>
                            <ul className="d-flex align-items-center flex-wrap">
                              <li style={{ flex: "0" }}>
                                <a
                                  to=""
                                  disabled={isActive}
                                  onClick={() => handleRemove(filtId)}
                                  className="minusBtn"
                                >
                                  <span className="icon-Group-271"></span>
                                </a>
                              </li>
                              <li style={{ flex: "1" }}>
                                {/* {conditionFilters[filtId].inputBox ? ( */}
                                <input
                                  placeholder="Event attribute name..."
                                  // name={
                                  //   conditionFilters[filtId].filterValueTypeId || ""
                                  // }
                                  // value={conditionFilters[filtId].filterValue}
                                  // onChange={(e, filtId) => {
                                  //   conditionFilters[filtId].filterValue =
                                  //     e.target.value;
                                  // }}
                                  required
                                  name={
                                    conditionFilters[filtId]
                                      .filterValueTypeId || ""
                                  }
                                  id={"typeInput" + filtId}
                                  className="kwDesign in1"
                                  type="text"
                                  value={conditionFilters[filtId].filterValue}
                                  onChange={(e) => handleType(e, filtId)}
                                // style={{
                                //   marginLeft: "20px",
                                //   marginRight: "20px",
                                // }}
                                />
                                {/* // ) : (
													// 	<select id="drop3" className="kwDesign2" */}
                                {/* // 		value={conditionFilters[filtId].filterValue}
													// 		onChange={(e) => handleDrop3Change(e, filtId)} required>
													// 		<option value="">Select</option>
													// 		{dropdown[parentId] */}
                                {/* // 			? dropdown[parentId].filterActions[conditionFilters[filtId].id2] && dropdown[parentId].filterActions[conditionFilters[filtId].id2].filterValues.map((data, index) => (
													// 				<option key={index} */}
                                {/* // 					name={data.id}
													// 					value={data.name}>
													// 					{data.name}
													// 				</option>
													// 			))
													// 			: ""}
													// 	</select>
													// )} */}
                              </li>

                              <li style={{ flex: "1" }}>
                                {/* {conditionFilters[filtId].inputBox ? ( */}

                                <select
                                  id={"drop2" + filtId}
                                  className="kwDesign2 in2"
                                  // value={ts}
                                  onChange={(e) => {
                                    handleDrop2Change(e, filtId);
                                  }}
                                  //id={"drop2" + filtId}
                                  value={
                                    conditionFilters[filtId].filterActionId
                                  }
                                  required
                                >
                                  <option value="">Select</option>
                                  <option value="number">Number</option>
                                  <option value="string">String</option>
                                  <option value="dateTime">DateTime</option>

                                  {/* {dropdown[parentId]
															? dropdown[parentId].filterActions.map((data, index) => (
																<option key={index} value={data.id}>
																	{data.name}
																</option>
															))

															: ""} */}
                                </select>

                                {/* <input
                              placeholder="Event attribute type..."
                              // name={
                              //   conditionFilters[filtId].filterValueTypeId || ""
                              // }
                              id={"typeInput2" + filtId}
                              className="kwDesign in2"
                              type="text"
                              value={conditionFilters[filtId].filterValue2}
                              required
                              // onChange={(filtId) => {
                              //   conditionFilters[filtId].filterValue =
                              //     this.value;
                              // }}
                              style={{
                                marginLeft: "40px",
                                marginRight: "40px",
                              }}
                            /> */}
                                {/* // ) : (
													// 	<select id="drop3" className="kwDesign2" */}
                                {/* // 		value={conditionFilters[filtId].filterValue}
													// 		onChange={(e) => handleDrop3Change(e, filtId)} required>
													// 		<option value="">Select</option>
													// 		{dropdown[parentId] */}
                                {/* // 			? dropdown[parentId].filterActions[conditionFilters[filtId].id2] && dropdown[parentId].filterActions[conditionFilters[filtId].id2].filterValues.map((data, index) => (
													// 				<option key={index} */}
                                {/* // 					name={data.id}
													// 					value={data.name}>
													// 					{data.name}
													// 				</option>
													// 			))
													// 			: ""}
													// 	</select>
													// )} */}
                              </li>
                              <li style={{ flex: "0" }}>
                                <div
                                  className="kwCheckbox"
                                  style={{ display: "inline" }}
                                >
                                  <input
                                    onChange={() => {
                                      var rr = [...conditionFilters];
                                      rr[filtId].optional =
                                        !conditionFilters[filtId].optional;
                                      setConditionFilters(rr);
                                    }}
                                    type="checkbox"
                                    id={"logged_in1" + filtId}
                                    className="opt"
                                    checked={conditionFilters[filtId].optional}
                                  />

                                  <label
                                    className="kwCheckboxText "
                                    style={{ paddingLeft: "20px" }}
                                    for={"logged_in1" + filtId}
                                  >
                                    optional
                                  </label>
                                </div>
                              </li>
                            </ul>
                          </li>
                        </ul>
                      );
                    })}
                  <div className="addNewButton">
                    <a to="" onClick={creatediv} className="plusIconText">
                      <span className="icon-Group-272" /> Add New
                    </a>
                  </div>
                </div>
              </div>
              </>
            )}
            {error ? (
              <small style={{ color: "red" }}>
                {" "}
                Event attributes should consist of alphabetic characters,
                numbers and underscores only{" "}
              </small>
            ) : (
              ""
            )}
            <br />
          </div>
          <div className="previewAudience">
          {saved ? (
          
            <input
              disabled={saved}
              type="submit"
              name="Save"
              style={{
                color: 'rgb(192, 192, 192)',
                backgroundColor: 'rgb(225, 225, 225)',
                borderColor: 'rgb(225, 225, 225)'
              }}
              className="button_disabled lg_btn primary"
              value="Save"
            />
          ) : (
            <input
              type="submit"
              name="Save"
              style={{ cursor: "pointer" }}
              className="lg_btn primary"
              value="Save"
            />
          )}
          </div>

          {showScript ? (
            <div
              style={{
                //  width: "90%",
                backgroundColor: "#F5F5F5",
                marginBottom: "30px",
                marginTop: "1%",
                minHeight: "100px",
                borderRadius: "10px",
                padding: "10px",
              }}
            >
              <ul>
                <li>
                  <a
                    href="#"
                    type="button"
                    onClick={copy}
                    style={{
                      display: "block",
                      marginLeft: "98%",
                      borderWidth: "0px",
                    }}
                  >
                    <i class="far fa-copy"></i>
                  </a>
                </li>
                <li>
                  <pre
                    style={{
                      backgroundColor: grey,
                      fontSize: "large",
                      textAlign: "start",
                    }}
                  >
                    {scriptCode}
                  </pre>
                </li>
              </ul>
            </div>
          ) : (
            ""
          )}
          {companyKey ? (
            <ul style={{ padding: "0px", paddingTop: "42px" }}>
              <li>
                <label className="large" style={{ paddingLeft: "5px" }}>
                  Company key
                </label>
                <a
                  href="#"
                  type="button"
                  onClick={copy2}
                  style={{
                    display: "inline",
                    marginLeft: "5%",
                    borderWidth: "0px",
                  }}
                >
                  <i class="far fa-copy"></i>
                </a>
              </li>
              <li>
                <input
                  id="audienceName"
                  type="text"
                  className="kwDesign max351"
                  value={companyKey}
                ></input>
              </li>
            </ul>
          ) : (
            ""
          )}
        </div>
      </form>
    </div>
  );
}

export default CreateEvent;
